import React from "react";
import "./styles.scss";
import { ReactComponent as ExclamationMark } from "../../../../public/icons/circle-exclamation-mark.svg";
import RollOver from "../../../RollOver";

const htmlWithText =
  "BASED ON THE MUSIC GENRES YOU LIKE. YOU CAN ADJUST THOSE AT ANY TIME UNDER <b><a style='text-decoration:underline' className='text-white' href='/settings'>MY PROFILE > EDIT PROFILE</a><b>";

function NewsfeedToggleTab({ tab, isActive, setAtiveTab, isSticky }) {
  const className = `genre-i-liked ${isSticky ? "sticky" : ""}`;
  return (
    <div onClick={() => setAtiveTab(tab)} className={`tab d-flex ${isActive ? "active" : ""}`}>
      <p className="m-0">{tab.label}</p>
      {isActive && tab.value === "genres_you_like" && (
        <RollOver className={className} html={htmlWithText} placement={isSticky ? "bottom" : "top"}>
          <ExclamationMark className="ml-2" />
        </RollOver>
      )}
    </div>
  );
}
export default NewsfeedToggleTab;
